var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.62582 1.392L1.75938 1.24174C2.24889 0.729861 2.97814 0.473755 3.94646 0.473755H20.5416C21.4541 0.473755 22.1553 0.69647 22.6452 1.14157L22.6619 1.15826C22.7621 1.24742 22.8626 1.35293 22.9624 1.47547C22.9624 1.48683 22.9681 1.49784 22.9791 1.50886L22.9958 1.52556C23.3634 1.98201 23.5467 2.62745 23.5467 3.46221V12.9117C23.5357 14.9152 22.534 15.9169 20.5416 15.9169H3.94646C1.95405 15.9059 0.958008 14.9042 0.958008 12.9117V3.46221C0.958008 2.56067 1.18072 1.87048 1.62582 1.392ZM21.0925 2.10989C20.9256 2.06548 20.7419 2.04845 20.5419 2.05981H3.94646C3.82392 2.04879 3.70705 2.05413 3.59586 2.0765L12.1939 10.7914L21.0925 2.10989ZM2.54406 3.27856C2.53304 3.33433 2.53304 3.39543 2.54406 3.46221V12.9117C2.54406 13.858 3.01153 14.3308 3.94646 14.3308H20.5416C21.4875 14.3308 21.9607 13.858 21.9607 12.9117V3.47891L12.7449 12.4777C12.5779 12.6336 12.3889 12.7114 12.1776 12.7114C11.9549 12.7004 11.7655 12.6223 11.6099 12.4777L2.54406 3.27856Z",
    fill: "url(#paint0_linear_348_6441)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.62598 1.39171C1.64835 1.35832 1.67606 1.32493 1.70945 1.29154C1.7208 1.26917 1.73717 1.25247 1.75954 1.24146L1.62598 1.39171Z",
    fill: "url(#paint1_linear_348_6441)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_348_6441",
    x1: 0.958008,
    y1: 0.473755,
    x2: 15.348,
    y2: 21.5221,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEC163"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEC163"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_348_6441",
    x1: 1.62598,
    y1: 1.24146,
    x2: 1.7752,
    y2: 1.37409,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEC163"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEC163"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.eaa03a8cf35f1d23d7450e031d8a53a7.svg";
export { ForwardRef as ReactComponent };